import requestTypes from './requestTypes';
import generateInstallerLink from './installerLinkGenerator';

const RealApi = {
    getMe: () => requestTypes.get('users/me'),
    startCreateImageOperation: details => requestTypes.post('images', details),
    fetchSqlServerInstances: (params) => requestTypes.get('locations/instances', params),
    requestSqlServerInstanceValidation: serverInstance => requestTypes.post('locations/instances/validations', serverInstance),
    addSqlServerInstance: serverInstance => requestTypes.post('locations/instances', serverInstance),
    fetchInstanceDetails: (serverInstanceId) => requestTypes.get('locations/instances/' + serverInstanceId),
    fetchImageDestinationLocations: (params) => requestTypes.get('imagelocations/fileshares', params),
    requestImageDestinationLocationValidation: validationRequest => requestTypes.post('imagelocations/fileshares/validations', validationRequest),
    addImageDestinationLocation: imageDestinationLocation => requestTypes.post('imagelocations/fileshares', imageDestinationLocation),
    fetchBackupLocations: (params) => requestTypes.get('locations/backupLocations', params),
    addBackupLocation: backupLocation => requestTypes.post('locations/backupLocations', backupLocation),
    requestBackupLocationValidation: backupLocation => requestTypes.post('locations/backupLocations/validations', backupLocation),
    updateBackupLocation: backupLocation => requestTypes.post('locations/backupLocations/' + backupLocation.id, backupLocation),
    fetchImages: (params) => requestTypes.get('images', params),
    fetchImage: (imageId) => requestTypes.get('images/' + imageId),
    fetchClones: (params) => requestTypes.get('clones', params),
    fetchAgents: (params) => requestTypes.get('agents', params),
    startCreateCloneOperation: cloneDetails => requestTypes.post('clones', cloneDetails),
    downloadInstaller: () => window.open(generateInstallerLink(), '_blank'),
    deleteClone: cloneId => requestTypes.deleteItem('clones/' + cloneId),
    deleteImage: imageId => requestTypes.deleteItem('images/' + imageId),
    fetchPermissions: () => requestTypes.get('permissions'),
    updatePermissions: (updateRequest) => requestTypes.put('permissions', updateRequest),
    fetchLicence: () => requestTypes.get('licence')
};

export default RealApi;



// WEBPACK FOOTER //
// ./src/js/serverApi/realApi.js